import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from "axios"
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import i18n from './i18n'
import VueMask from 'v-mask'

Vue.use(VueSweetalert2);
Vue.use(VueMask);

axios.defaults.baseURL = process.env.VUE_APP_URL_API;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
